import { templates } from "../entry";
import { dataContainer } from "../entry";

export function populate(data) {
    if (!data || !data.length) {
        dataContainer.html("<p>No listings found</p>");
        return;
    }

    const html = templates.propertyTemplate({ data });
    dataContainer.html(html);
}
